/**
 * Re-exports codegen types for the requirements workspace so existing import
 * paths (`@ben/columbia/api/requirements`) keep working.
 *
 * The fetch functions that used to live here have been removed — use the
 * generated hooks from `@ben/api` directly instead.
 */
export type {
  ChangeRef,
  ChildGroupSummary,
  EntityRef,
  Requirement,
  RequirementGroupDetail,
  RequirementGroupPage,
  RequirementGroupSummary,
  RequirementPage,
  RunRef,
} from '@ben/api/gen';

// ─── Page-size constants used by the UI ───────────────────────────────────────

/**
 * Card-per-row list — smaller than the requirements page size because each
 * card takes more vertical space than a single row.
 */
export const GROUPS_PAGE_SIZE = 10;

/**
 * The requirements list fetches the whole tree in one shot so domain sections
 * don't cut off mid-page. The endpoint caps page_size at 100.
 */
export const REQUIREMENTS_PAGE_SIZE = 100;
